import { createSlice } from "@reduxjs/toolkit";
import { FORGOT_PASSWORD, LOGIN_USER } from "./Auth.action";

const AuthSlice = createSlice({
    name: "user",
    initialState:{
        user: null,
        isAuthenticated: false,
        isLoading: false,
        error: null,
        forgotUser :{}
    },
    extraReducers:(builder) =>{
        builder
        .addCase(LOGIN_USER.pending, (state) => {
            state.isLoading = true;
            state.error = null;
        })
        .addCase(LOGIN_USER.fulfilled,(state,action) => {
            state.isLoading = false;
            state.isAuthenticated = true;
            state.user = action.payload;
        })
        .addCase(LOGIN_USER.rejected, (state, action) => {
            state.isLoading = false;
            state.error = action.error.message;
        })
        .addCase(FORGOT_PASSWORD.pending, (state) => {
            state.isLoading = true;
          })
          .addCase(FORGOT_PASSWORD.fulfilled, (state, action) => {
            state.isLoading = false;
            state.forgotUser = action?.payload?.r;
          })
          .addCase(FORGOT_PASSWORD.rejected, (state) => {
            state.error = true;
            state.isLoading = false;
          });
    }
})
export default AuthSlice